// Which localized user guides exist per role (must match the generated files in
// public/guides and the role-scoped languages the guides are built for).
const GUIDE_LANGS = {
  employee: ['en', 'hu', 'pl', 'ro', 'bg', 'cs', 'sk', 'sr', 'hr'],
  customer: ['en', 'da', 'de'],
};

/**
 * Resolve the static user-guide URL for a role in the given UI language,
 * falling back to English when that language has no guide for the role.
 * @param {'employee'|'customer'} role
 * @param {string} lang current i18n language (e.g. 'bg', 'en-US')
 */
export const guideHref = (role, lang) => {
  const langs = GUIDE_LANGS[role] || ['en'];
  const base = String(lang || 'en').split('-')[0];
  const l = langs.includes(base) ? base : 'en';
  return `/guides/${role}.${l}.html`;
};

export default guideHref;
